import {Model} from "@vuex-orm/core";

export default class WebsitePackageRegion extends Model {

    static entity = 'websitePackageRegion';

    static primaryKey = ['website_package_id', 'region_id'];

    static fields () {
        return {
            website_package_id: this.number(null).nullable(),
            region_id: this.number(null).nullable(),
        }
    }
}
